import { useSelector } from "react-redux";
import { CART_CONSTRUCTION } from "../utils/constants";
import { Link } from "react-router-dom";
import ItemCard from "./ItemCard.js";

export default function Cart() {
  const cartItems=useSelector((store)=>store.cart.items);


  return (
    <div className="Cart-page m-3 mb-6 mt-[90px] ">
      <div className="text-3xl text-center font-bold m-4">Cart Items</div>
      {cartItems?.map((i) => <ItemCard key={i?.card?.info?.id} item={i} />)}
    </div>
  );
}
